import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { YardMapConfigurationComponent } from './component/yard-map-configuration/yard-map-configuration.component';

const routes: Routes = [
  { path: '', component: YardMapConfigurationComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class YardMapConfigurationRoutingModule { }
